import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Container, Box, IconButton, Tooltip, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Information from './Information';
// import capitalize from '../. ./../Helpers/StringsFormatting/capitalize';
import { culture, options } from '../../../Helpers/dates';
import StatusChip from '../../../Components/Chip/StatusChip';
import { PRACTICE_ICONS, PRACTICE_COLORS } from '../Utils/constants';
import { getForcedMessages } from '../../../i18n';
import ConfirmPopup from '../../../Components/Popup/ConfirmPopup';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';

const useStyles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '2%',
    alignItems: 'center',
    maxHeight: '80px',

    pt: '12px',
    pb: '12px',
  },
});

const PracticeListItem = function PracticeListItem({
  data = {},
  onClick = () => {},
  onDelete = () => {},
}) {
  const intl = useIntl();
  const italianTerms = getForcedMessages('it');
  const classes = useStyles();

  const [confirmOpen, setConfirmOpen] = useState(false);

  const openConfirmDeletion = (event) => {
    event.stopPropagation();

    setConfirmOpen(event.currentTarget);
  };

  return (
    <>
      <Container
        id="data-entry"
        sx={classes.root}
        style={{ maxWidth: 'unset' }}
        onClick={() => onClick(data)}
      >
        {/*         <Information
          caption={
            data.deutscheBankCustomer
              ? intl.messages.DEUTSCHEBANKCUSTOMER
              : intl.messages.NOT_CUSTOMER
          }
          value={`${capitalize(data.customerName)} ${capitalize(
            data.customerSurname
          )}`}
          inverted
        /> */}
        <Information
          value={capitalize(`${data?.customerName} ${data?.customerSurname}`)}
        />
        <Information
          caption={intl.messages.PRACTICENUMBER}
          value={data.practiceNumber}
        />
        <Information
          caption={intl.messages.DATELOADINGPRACTICE}
          value={
            data.dateLoadingPractice
              ? new Date(data.dateLoadingPractice).toLocaleDateString(
                  culture,
                  options
                )
              : null
          }
        />
        <Information
          caption={intl.messages.LIQUIDATIONDATE}
          value={
            data.liquidationDate
              ? new Date(data.liquidationDate).toLocaleDateString(
                  culture,
                  options
                )
              : null
          }
        />
        <Information
          caption={intl.messages.PRODUCTCODE}
          value={data.productCode}
        />
        <Box
          sx={{
            maxWidth: "130px",
            minWidth: "130px",
            display: "flex",
            justifyContent: "center",
            alignItems: "stretch"
          }}>
          <StatusChip
            status={
              Object.keys(italianTerms)?.find(
                (keyName) =>
                  italianTerms[keyName].toUpperCase() ===
                  data?.practiceState?.toUpperCase()
              ) || 'NOTINSERTED'
            }
            options={PRACTICE_ICONS}
            colors={PRACTICE_COLORS}
          />
        </Box>
        <Tooltip title={intl.messages.DELETE} placement="bottom">
          <IconButton key={data.id} onClick={openConfirmDeletion}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Container>
      <Divider />
      <ConfirmPopup
        confirmText={intl.messages.CONFIRM_DELETE_PRACTICE}
        open={Boolean(confirmOpen)}
        anchorEl={confirmOpen}
        close={() => setConfirmOpen(null)}
        handleConfirm={() => onDelete(data.id)}
      />
    </>
  );
};

PracticeListItem.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
};

export default PracticeListItem;
